import { graphql } from 'react-relay';

export const needsAuthenticationQuery = graphql`
  query personalDeductionNeedsAuthenticationQuery {
    isCertNeed {
      result
      errors {
        code
        message
      }
    }
  }
`;
